import { render } from "./PotentialScoringV1.vue?vue&type=template&id=7c67faf4&scoped=true&lang=pug"
import script from "./PotentialScoringV1.vue?vue&type=script&setup=true&lang=js"
export * from "./PotentialScoringV1.vue?vue&type=script&setup=true&lang=js"

import "./PotentialScoringV1.vue?vue&type=style&index=0&id=7c67faf4&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c67faf4"]])

export default __exports__